import {
    FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST,
    FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS,
    FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE,
    FETCH_AGENT_PROGRAMME_REQUEST,
    FETCH_AGENT_PROGRAMME_SUCCESS,
    FETCH_AGENT_PROGRAMME_FAILURE,
    FETCH_AGENT_CERTIFICATION_REQUEST,
    FETCH_AGENT_CERTIFICATION_SUCCESS,
    FETCH_AGENT_CERTIFICATION_FAILURE,
    FETCH_AGENT_OPERATIONS_REQUEST,
    FETCH_AGENT_OPERATIONS_SUCCESS,
    FETCH_AGENT_OPERATIONS_FAILURE,
    FETCH_TOP_PERFORMING_AGENTS_REQUEST,
    FETCH_TOP_PERFORMING_AGENTS_SUCCESS,
    FETCH_TOP_PERFORMING_AGENTS_FAILURE,
    FETCH_AGENT_PERFORMANCE_REQUEST,
    FETCH_AGENT_PERFORMANCE_SUCCESS,
    FETCH_AGENT_PERFORMANCE_FAILURE,
    FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST,
    FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS,
    FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE,
} from "../actions/types";

const initialState = {
    dashboard: null,
    programme: null,
    certification: null,
    operations: null,
    topPerformingAgents: [],
    agentPerformance: [],
    customerSatisfaction: null,

    dashboardLoading: false,
    programmeLoading: false,
    certificationLoading: false,
    operationsLoading: false,
    topPerformingAgentsLoading: false,
    agentPerformanceLoading: false,
    customerSatisfactionLoading: false,

    dashboardError: null,
    programmeError: null,
    certificationError: null,
    operationsError: null,
    topPerformingAgentsError: null,
    agentPerformanceError: null,
    customerSatisfactionError: null,

    error: null,
    message: "",
};

const agentAnalyticsReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST:
            return {
                ...state,
                dashboardLoading: true,
                dashboardError: null,
            };

        case FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboardLoading: false,
                dashboard: action.payload,
                dashboardError: null,
            };

        case FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE:
            return {
                ...state,
                dashboardLoading: false,
                dashboardError: action.payload,
            };


        case FETCH_AGENT_PROGRAMME_REQUEST:
            return {
                ...state,
                programmeLoading: true,
                programmeError: null,
            };

        case FETCH_AGENT_PROGRAMME_SUCCESS:
            return {
                ...state,
                programmeLoading: false,
                programme: action.payload,
                programmeError: null,
            };

        case FETCH_AGENT_PROGRAMME_FAILURE:
            return {
                ...state,
                programmeLoading: false,
                programmeError: action.payload,
            };


        case FETCH_AGENT_CERTIFICATION_REQUEST:
            return {
                ...state,
                certificationLoading: true,
                certificationError: null,
            };

        case FETCH_AGENT_CERTIFICATION_SUCCESS:
            return {
                ...state,
                certificationLoading: false,
                certification: action.payload,
                certificationError: null,
            };

        case FETCH_AGENT_CERTIFICATION_FAILURE:
            return {
                ...state,
                certificationLoading: false,
                certificationError: action.payload,
            };


        case FETCH_AGENT_OPERATIONS_REQUEST:
            return {
                ...state,
                operationsLoading: true,
                operationsError: null,
            };

        case FETCH_AGENT_OPERATIONS_SUCCESS:
            return {
                ...state,
                operationsLoading: false,
                operations: action.payload,
                operationsError: null,
            };

        case FETCH_AGENT_OPERATIONS_FAILURE:
            return {
                ...state,
                operationsLoading: false,
                operationsError: action.payload,
            };


        case FETCH_TOP_PERFORMING_AGENTS_REQUEST:
            return {
                ...state,
                topPerformingAgentsLoading: true,
                topPerformingAgentsError: null,
            };

        case FETCH_TOP_PERFORMING_AGENTS_SUCCESS:
            return {
                ...state,
                topPerformingAgentsLoading: false,
                topPerformingAgents:
                    Array.isArray(action.payload)
                        ? action.payload
                        : [],
                topPerformingAgentsError: null,
            };

        case FETCH_TOP_PERFORMING_AGENTS_FAILURE:
            return {
                ...state,
                topPerformingAgentsLoading: false,
                topPerformingAgentsError:
                    action.payload,
            };


        case FETCH_AGENT_PERFORMANCE_REQUEST:
            return {
                ...state,
                agentPerformanceLoading: true,
                agentPerformanceError: null,
            };

        case FETCH_AGENT_PERFORMANCE_SUCCESS:
            return {
                ...state,
                agentPerformanceLoading: false,
                agentPerformance:
                    Array.isArray(action.payload)
                        ? action.payload
                        : [],
                agentPerformanceError: null,
            };

        case FETCH_AGENT_PERFORMANCE_FAILURE:
            return {
                ...state,
                agentPerformanceLoading: false,
                agentPerformanceError:
                    action.payload,
            };


        case FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST:
            return {
                ...state,
                customerSatisfactionLoading: true,
                customerSatisfactionError: null,
            };

        case FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS:
            return {
                ...state,
                customerSatisfactionLoading: false,
                customerSatisfaction:
                    action.payload,
                customerSatisfactionError: null,
            };

        case FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE:
            return {
                ...state,
                customerSatisfactionLoading: false,
                customerSatisfactionError:
                    action.payload,
            };

        default:
            return state;
    }
};

export default agentAnalyticsReducer;